import './StatusPicker.scss';

import { Field, useField } from 'formik';
import { Label } from '../ui/label';
import { type StatusOption, status } from './config';

interface StatusPickerProps {
	name: string;
}

export const StatusPicker = ({ name }: StatusPickerProps) => {
	const [, meta] = useField(name);

	return (
		<>
			<fieldset className='status-picker'>
				{status.map((status: StatusOption) => {
					return (
						<div className='status-picker__container' key={status.label}>
							<Field
								className='status-picker__checkbox'
								id={status.value.toLowerCase()}
								type='checkbox'
								name={name}
								value={status.value}
							/>
							<Label
								className='status-picker__label'
								htmlFor={status.value.toLowerCase()}
							>
								{status.label}
							</Label>
						</div>
					);
				})}
			</fieldset>
			{meta.error && meta.touched && <p className='error'>{meta.error}</p>}
		</>
	);
};
